import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, Search, Calendar, User } from 'lucide-react';
import { triggerHaptic } from '../../utils/haptics';
import './BottomNav.css';

const BottomNav = () => {
  const location = useLocation();
  
  // Exclude bottom nav on certain routes if necessary
  const hiddenRoutes = ['/login', '/register'];
  if (hiddenRoutes.includes(location.pathname)) return null;

  const handleTabClick = () => {
    triggerHaptic.light();
  };

  return (
    <nav className="mobile-bottom-nav d-md-none">
      <NavLink to="/" onClick={handleTabClick} className={({isActive}) => isActive ? "nav-tab active" : "nav-tab"}>
        <Home size={24} />
        <span>Home</span>
      </NavLink>
      <NavLink to="/roles" onClick={handleTabClick} className={({isActive}) => isActive ? "nav-tab active" : "nav-tab"}>
        <Search size={24} />
        <span>Roles</span>
      </NavLink>
      <NavLink to="/workshops" onClick={handleTabClick} className={({isActive}) => isActive ? "nav-tab active" : "nav-tab"}>
        <Calendar size={24} />
        <span>Workshops</span>
      </NavLink>
      <NavLink to="/dashboard" onClick={handleTabClick} className={({isActive}) => isActive ? "nav-tab active" : "nav-tab"}>
        <User size={24} />
        <span>Profile</span>
      </NavLink>
    </nav>
  );
};

export default BottomNav;
